import { render, staticRenderFns } from "./ProcessInfo.vue?vue&type=template&id=913b15e6"
import script from "./ProcessInfo.vue?vue&type=script&lang=ts"
export * from "./ProcessInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports